// Uploaded File DTOs based on backend API

export interface UploadedFileDto {
  id: string
  name: string
  s3Key: string
  size: number
  mimeType: string
  url: string
  createdAt: string
  updatedAt: string
}

export interface DeleteUploadedFileResponseDto {
  message: string
}

// File validation types
export interface FileValidationOptions {
  allowedTypes: string[]
  maxSize: number // in bytes
}

export interface FileValidationResult {
  valid: boolean
  error?: string
}

// Default validation constants
export const DEFAULT_IMAGE_TYPES = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/gif",
  "image/webp",
  "image/svg+xml",
]

export const DEFAULT_PDF_TYPES = ["application/pdf"]

export const DEFAULT_MAX_SIZE = 5 * 1024 * 1024 // 5MB

